import request from '@/src/utils/request'

/**
 * 取得加購商品列表（不含已軟刪）
 * @param {object} params - 查詢參數
 * @param {string} [params.keyword] - 模糊搜尋關鍵字
 * @param {string} [params.status] - 狀態篩選 'active' | 'inactive'
 * @param {string[]} [params.tagIds] - 標籤 ID 陣列
 * @returns {Promise}
 */
export const getHotelGoodsList = async (params = {}) => {
  return await request.get('/admin/hotel/goods', { params })
}

/**
 * 取得加購商品下拉/選擇清單（建立訂單加購清單使用）
 * @param {object} params
 * @returns {Promise}
 */
export const getHotelGoodsOptions = async (params = {}) => {
  return await request.get('/admin/hotel/goods/options', { params })
}

/**
 * 建立加購商品
 * @param {object} data
 * @param {string} data.name
 * @param {string} [data.description]
 * @param {string} [data.image]
 * @param {number[]} [data.categoryIds]
 * @param {string[]} [data.tagIds]
 * @param {string} data.status - 'active' | 'inactive'
 * @param {Array<{categoryId: number, price: number, cost: number, origin: number}>} [data.prices]
 * @returns {Promise}
 */
export const createHotelGoods = async (data) => {
  return await request.post('/admin/hotel/goods', data)
}

/**
 * 取得單筆加購商品
 * @param {string} goodsId
 * @returns {Promise}
 */
export const getHotelGoodsDetail = async (goodsId) => {
  return await request.get(`/admin/hotel/goods/${goodsId}`)
}

/**
 * 部分更新加購商品（含 prices 時全量取代價格列；tagIds 可更新標籤快照）
 * @param {string} goodsId
 * @param {object} data
 * @returns {Promise}
 */
export const updateHotelGoods = async (goodsId, data) => {
  return await request.patch(`/admin/hotel/goods/${goodsId}`, data)
}

/**
 * 軟刪除加購商品（status=deleted）
 * @param {string} goodsId
 * @returns {Promise}
 */
export const deleteHotelGoods = async (goodsId) => {
  return await request.delete(`/admin/hotel/goods/${goodsId}`)
}

/**
 * 批次調整加購商品排序（goodsIds 越前 sort 越大，列表預設依 sort desc）
 * @param {string[]} goodsIds - 排序後的商品 ID 陣列（由前到後）
 * @returns {Promise}
 */
export const sortHotelGoods = async (goodsIds) => {
  return await request.post('/admin/hotel/goods/sort', { goodsIds })
}
